<template>
  <div style="padding: 0 15px">
    <div>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 17 }"
          :lg="{ span: 17 }"
        >
          <CollapseGruop>
            <div class="default-back-pd">
              <TasDetail
                @reload="reload"
                @create="addChild('add')"
                @openRemarkEdit="openRemarkEdit"
                :taskInfo="taskInfo"
                :disabled="isDisableEditForm"
                :isSuper="isSuper"
              >
                <TaskTopics :value="taskInfo.tskDescription" />
                <TaskFile
                  :tskInfoDocList="taskInfo.tskInfoDocList"
                  :fileIcons="fileIcons"
                />
              </TasDetail>
            </div>
          </CollapseGruop>
          <div v-if="!!taskInfo.todoCount">
            <CollapseGruop class="mt-2">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="default-back-pd">
                    <CollapseItem :title="$l('table_todo') || '待办事项'">
                      <TaskTodo
                        :tskInfoCode="tskInfoCode"
                        :disabled="isDisableEditForm"
                        @reload="$refs.taskLog.getData()"
                      />
                    </CollapseItem>
                  </div>
                </el-col>
              </el-row>
            </CollapseGruop>
          </div>
          <div v-if="!taskInfo.parentTskCode && tableData && tableData.length">
            <CollapseGruop class="mt-2">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="default-back-pd">
                    <CollapseChildList
                      :title="$l('table_subtask') || '子任务'"
                      :taskInfo="taskInfo"
                      :isSuper="isSuper"
                      @addChild="addChild('add')"
                    >
                      <ChildTable
                        class="mt-3"
                        ref="childTable"
                        :parentTskCode="tskInfoCode"
                        :disabled="isDisableEditForm"
                        :tableData="tableData"
                      />
                    </CollapseChildList>
                  </div>
                </el-col>
              </el-row>
            </CollapseGruop>
          </div>
          <!-- <div v-if="!!taskInfo.devTrackingCode">
            <CollapseGruop class="mt-2">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="default-back-pd">
                    <CollapseItem
                      :title="$l('table_selection_product') || '客人选中产品'"
                    >
                      <SelectionProduct
                        :devTrackingCode="taskInfo.devTrackingCode"
                      />
                    </CollapseItem>
                  </div>
                </el-col>
              </el-row>
            </CollapseGruop>
          </div> -->
          <div>
            <CollapseGruop class="mt-2">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="default-back-pd" style="padding-bottom: 2px">
                    <CollapseItem :title="$l('table_task_log') || '任务日志'">
                      <el-tabs v-model="activeName">
                        <el-tab-pane
                          :label="$l('table_task_remark') || '备注'"
                          name="notes"
                        >
                          <CollapseButtonList
                            :title="$l('table_table_remark') || '备注信息'"
                            :buttonList="buttonList"
                            :disabled="isDisableEditForm"
                            @command="remarkCommand"
                          >
                            <TaskRemark
                              ref="taskRemark"
                              :tskInfoCode="tskInfoCode"
                              :expoMeetingCode="taskInfo.expoMeetingCode"
                              :disabled="isDisableEditForm"
                            />
                          </CollapseButtonList>
                        </el-tab-pane>
                        <el-tab-pane
                          :label="$l('table_task_log') || '日志'"
                          name="log"
                        >
                          <TaskLog ref="taskLog" :tskInfoCode="tskInfoCode" />
                        </el-tab-pane>
                      </el-tabs>
                    </CollapseItem>
                  </div>
                </el-col>
              </el-row>
            </CollapseGruop>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 7 }"
          :lg="{ span: 7 }"
        >
          <CollapseGruop>
            <div class="default-back-right mt-2">
              <CollapseItem :title="$l('table_task_arrangement') || '任务安排'">
                <TaskAttendance :taskInfo="taskInfo" />
              </CollapseItem>
            </div>
          </CollapseGruop>
          <CollapseGruop>
            <div class="default-back-right mt-2">
              <CollapseItem :title="$l('table_task_date') || '日期'">
                <TaskDate :taskInfo="taskInfo" />
              </CollapseItem>
            </div>
          </CollapseGruop>
        </el-col>
      </el-row>
    </div>
    <!-- <div v-if="isPQ">
      <CollapseGruop class="mt-2">
        <el-row :gutter="10">
          <el-col :span="24">
            <div class="default-back-pd">
              <CollapseItem
                :title="$l('table_customer_quotation') || '客人选中产品报价'"
              >
                <SampleTask
                  :tskInfoCode="taskInfo.tskInfoCode"
                  :expoMeetingCode="taskInfo.expoMeetingCode"
                  :disabled="isDisableEditForm"
                />
              </CollapseItem>
            </div>
          </el-col>
        </el-row>
      </CollapseGruop>
    </div>

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :parentTskCode="editOptions.parentTskCode"
      :meetingTaskNode="'B'"
    </div> -->
    <AddForm
      :visible.sync="addOptions.visible"
      :parentTskCode="addOptions.parentTskCode"
      @reload="getChildData"
    />
  </div>
</template>
<script>
import CollapseGruop from './components/collapse/gruop.vue'
import CollapseItem from './components/collapse/item.vue'
import CollapseChildList from './components/collapse/child-list.vue'
import CollapseButtonList from './components/collapse/button-list.vue'
import TasDetail from './components/collapse/tas-detail.vue'
import TaskTopics from './components/task-topics'
import TaskFile from './components/task-file'
import TaskAttendance from './components/task-attendance'
import TaskDate from './components/task-date'
// import SampleTask from './components/sample-task'
import ChildTable from './components/child-table'
import TaskLog from './components/task-log'
import TaskTodo from './components/task-todo'
import TaskRemark from './components/task-remark'
import SelectionProduct from './components/selection-product'
import { request } from '@/api/service'
import AddForm from '../components/add-form'
export default {
  name: 'personal-myTravel-detail',
  components: {
    CollapseGruop,
    CollapseItem,
    CollapseChildList,
    CollapseButtonList,
    TasDetail,
    TaskTopics,
    TaskFile,
    TaskAttendance,
    TaskDate,
    // SampleTask,
    ChildTable,
    AddForm,
    TaskLog,
    TaskTodo,
    TaskRemark,
    SelectionProduct,
  },
  data() {
    return {
      taskInfo: {},
      fileIcons: {},
      tableData: [],
      buttonList: [{ menuType: 'add', icon: 'el-icon-plus' }],
      editOptions: {
        visible: false,
        type: 'edit',
        parentTskCode: '',
      },
      activeName: 'notes',
      addOptions: { visible: false, parentTskCode: '' },
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    tskInfoCode() {
      return this.params.code
    },
    isPQ() {
      return this.taskInfo.tskType == 'PQ'
    },
    isSuper() {
      return this.taskInfo.super
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.taskInfo.tskStatus == 'Y' || this.taskInfo.tskStatus == 'D'
    },
  },
  async mounted() {
    await this.getFileIcons()
    await this.getData()
    await this.getChildData()
  },
  methods: {
    reload() {
      this.getData()
      this.$refs.taskLog.getData()
      this.getChildData()
    },
    async getData() {
      this.loading = true
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .personalTskInfoDetailApi({
          tskInfoCode: this.tskInfoCode,
          localTimeZone,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.taskInfo = res.body
    },
    async getChildData() {
      if (!this.tskInfoCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      this.$api
        .personalTskInfoChildListApi({
          localTimeZone,
          parentTskCode: this.tskInfoCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    addChild() {
      this.addOptions = {
        visible: true,
        parentTskCode: this.taskInfo.tskInfoCode,
      }
    },
    async remarkCommand({ menuType }) {
      if (!menuType) return

      switch (menuType) {
        case 'add':
          this.$refs.taskRemark.openEdit({ type: 'add' })
          break
        default:
          console.error('menuType configuration error:', menuType)
      }
    },
    openRemarkEdit() {
      this.$refs.taskRemark.openEdit({ type: 'add' })
    },
  },
}
</script>
<style lang="scss">
.bg-transparent-meetingSet {
  padding: 0px !important;
  background-color: transparent !important;
  margin: 15px 0 !important;
  .layout-theme-container-main-body {
    padding-top: 0px !important;
  }
}
</style>
<style lang="scss" scoped>
::v-deep {
  .el-tag--High {
    color: white;
    background-color: #fa5c7c;
    border: none;
  }
  .el-tag--Medium {
    color: white;
    background-color: #6c757d;
    border: none;
  }
  .el-tag--Low {
    color: white;
    background-color: #13cf97;
    border: none;
  }
  .el-tag--Y {
    color: #fa561f;
    background-color: #fff2e8;
    border-color: rgba($color: #fa561f, $alpha: 0.6);
  }
}
.default-back-pd {
  background: white;
  padding: 0px 30px 30px 0px;
  border-radius: 5px;
}
.default-back-right {
  background: white;
  padding: 0px 0px 30px 0px;
  border-radius: 5px;
}
</style>
